import InPlaceError from "components/in-place-error/InPlaceError";
import { Label } from "../input/Input";
import classNames from "classnames";
export interface PhoneInputProps {
  label: string;
  errorMessage?: string;
  onChange?(phoneNumber: string): void;
  value?: string;
  placeholder: string;
  isReadOnly?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const PhoneNumberInput = ({ label, errorMessage, onChange, value, placeholder, isReadOnly = false, onKeyDown }: PhoneInputProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.value);
  };
  const inputClass = classNames({
    input: true,
    "input--read-only": isReadOnly,
    "input--error": errorMessage,
  });
  return (
    <div className="input-container">
      {label && <Label label={label} />}
      <div className="input__wrapper">
        <input type="text" value={value} onChange={handleChange} onKeyDown={onKeyDown} className={inputClass} placeholder={placeholder} readOnly={isReadOnly} />
        {errorMessage && <InPlaceError errorPhrase={errorMessage} />}
      </div>
    </div>
  );
};

export default PhoneNumberInput;
